var rollBackVersion2 = '1.20240922.4.0';
var rollBackVersion1 = '1.20241028.2.0';
var signOffVersion = '1.20241111.2.1';
var fixForwardVersion1 = '1.20241111.2.2';
var fixForwardVersion2 = '1.20241111.2.3';
var fixForwardVersion3 = '1.20241111.2.4';
var rollBackVersion2KS = 'f2ab2145-c999-4262-bc55-d392b4acd2e1'; /*18/11/2024, KS for rollBackVersion2*/
var rollBackVersion1KS = '917f6e84-4884-41b0-8915-d2f0c213b197'; /*18/11/2024, KS for rollBackVersion1*/
var fixForwardVersion1KS = 'dc83606c-aa59-4d94-b5d9-b9a4316222b5'; /*18/11/2024, KS for fixForwardVersion1*/
var fixForwardVersion2KS = '2ac6a515-a751-4cf2-ba37-d70a3df65549'; /*18/11/2024, KS for fixForwardVersion2*/
var fixForwardVersion3KS = 'f243646c-6a00-4ab8-ad7a-edbef520d062'; /*18/11/2024, KS for fixForwardVersion3*/
export default function getSerpVersion(microsoftSearchBootstrapperKillSwitchesActive) {
    microsoftSearchBootstrapperKillSwitchesActive = microsoftSearchBootstrapperKillSwitchesActive !== null && microsoftSearchBootstrapperKillSwitchesActive !== void 0 ? microsoftSearchBootstrapperKillSwitchesActive : (microsoftSearchBootstrapperKillSwitchesActive = '[]');
    var searchBootstrapperKS = JSON.parse(microsoftSearchBootstrapperKillSwitchesActive);
    if (searchBootstrapperKS && searchBootstrapperKS.length > 0) {
        if (searchBootstrapperKS.indexOf(rollBackVersion2KS) >= 0) {
            return rollBackVersion2;
        }
        else if (searchBootstrapperKS.indexOf(rollBackVersion1KS) >= 0) {
            return rollBackVersion1;
        }
        else if (searchBootstrapperKS.indexOf(fixForwardVersion1KS) >= 0) {
            return fixForwardVersion1;
        }
        else if (searchBootstrapperKS.indexOf(fixForwardVersion2KS) >= 0) {
            return fixForwardVersion2;
        }
        else if (searchBootstrapperKS.indexOf(fixForwardVersion3KS) >= 0) {
            return fixForwardVersion3;
        }
        return signOffVersion;
    }
    return signOffVersion;
}
//# sourceMappingURL=getSerpVersion.js.map